import { ReactElement } from 'react'
import { colors } from '../../../../const/theme'
import { Question } from '../../../../redux/test/type'
import { H3 } from '../../../../typography'
import { SolutionWrapper } from './subcomponents'

interface SolutionProps {
  question: Question
}

const Solution = ({ question }: SolutionProps): ReactElement => {
  const { explanation = '' } = question || {}
  return (
    <SolutionWrapper>
      <H3 color={colors.gray}>Solution:</H3>
      <div dangerouslySetInnerHTML={{ __html: explanation }} />
    </SolutionWrapper>
  )
}

export default Solution
